import React from 'react'
import Nav from '../Nav/index'
import Footer from '../Footer/index'
import Hero from './Hero/index'
import Content from './Content/index'

import { Helmet } from 'react-helmet'
import 'bootstrap/dist/css/bootstrap.css'
import './css/style.css'


function index() {

  return (
    <>

      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11084448289"></script>

        <title> Mastering Monsoon Health: Expert Tips to Avoid Getting Sick</title>
        <meta name="description" content="Discover Kyno Health's expert tips to stay healthy during the
monsoon season. Learn how to boost your immunity and avoid common illnesses with our comprehensive guide." data-react-helmet="true" />

        <meta name="keywords" content="" data-react-helmet="true"/>

        <link rel="canonical" href="https://www.kynohealth.com/blog/mastering-monsoon-health-expert-tips"/>
                     </Helmet>

      <Nav />
      <Hero />
      <Content />
      <Footer />
    </>
  )
}





export default index